import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { useHasServers } from '@/hooks/useHasServers'
import { useActiveOrgId } from '@/hooks/useActiveOrgId'
import { useUserStore } from '@/store/UserStore'
import { Plus, ServerCog } from 'lucide-react'
import { cn } from '@/lib/utils'

export const CreateFirstServerPrompt = () => {
  const { hasServers, isLoading } = useHasServers()
  const { orgId } = useActiveOrgId()
  const hasCreatedFirstServer = useUserStore(
    (state) => state.hasCreatedFirstServer
  )

  if (isLoading || hasServers || !orgId || hasCreatedFirstServer) {
    return null
  }

  return (
    <div
      className={cn(
        'bg-primary/5 border border-primary/20 rounded-lg p-4 mx-4 mt-2',
        'flex items-center justify-between gap-4'
      )}
    >
      <div className="flex items-center gap-3">
        <ServerCog className="w-6 h-6 text-primary/60 flex-shrink-0" />
        <div>
          <p className="text-sm font-medium">Create your first server</p>
          <p className="text-xs text-muted-foreground">
            Start using the platform.
          </p>
        </div>
      </div>
      <Button asChild size="sm" className="gap-1.5">
        <Link
          to="/$orgId/dashboard/servers/new"
          params={{ orgId: orgId.toString() }}
        >
          <Plus className="w-4 h-4" />
          Create Server
        </Link>
      </Button>
    </div>
  )
}
